// import {Facebook, Linkedin, Youtube, Instagram } from "lucide-react";

export default function Footer() {
    const currentYear = new Date().getFullYear();

    return (
        <footer>
            <div className="mt-8 bg-white p-4 shadow-md rounded-lg">
                <p className="text-center">
                    &copy; {currentYear} Admin. All rights reserved.
                </p>
            </div>
        </footer>
    );
}